import React from 'react';
import { Tooltip } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Text } from '@/components/Typography';

export interface IconType {
	name?: string;
	position?: number;
	isComplete?: boolean;
	currentStep?: number;
	onStepNagivationClick: (step: number) => Promise<void>;
}

const DEFAULT_STEP_NAME_LENGTH = 23;

export function StepIcon({
	name = '',
	currentStep = 0,
	position = 0,
	isComplete = false,
	onStepNagivationClick
}: Readonly<IconType>): JSX.Element {
	const bigName = name.length > DEFAULT_STEP_NAME_LENGTH ? I18n.get(name) : undefined;

	const isDisabled = isComplete ? position !== currentStep : position > currentStep;

	function handleStepChange(): void {
		if (!isDisabled) {
			onStepNagivationClick(position);
		}
	}

	function setClassNamePositionBigger(): string {
		return currentStep < position
			? `step-number-hovered ${isDisabled ? 'disabled-step' : ''}`
			: 'step-checked-hovered';
	}

	function setClassNameCurrentBigger(): string {
		return currentStep > position ? 'step-checked' : `step-number ${isDisabled ? 'disabled-step' : ''}`;
	}

	if (currentStep === position) {
		return (
			<span className="step-name">
				<Tooltip title={bigName}>
					<Text ellipsis>{I18n.get(name)}</Text>
				</Tooltip>
			</span>
		);
	}

	return (
		<div className="step-hover">
			<button className={setClassNameCurrentBigger()} onClick={handleStepChange} disabled={isDisabled}>
				{position + 1}
			</button>
			<button className={setClassNamePositionBigger()} onClick={handleStepChange} disabled={isDisabled}>
				<Tooltip title={bigName}>
					<Text ellipsis>{I18n.get(name)}</Text>
				</Tooltip>
			</button>
		</div>
	);
}
